import React, { useState, useRef } from "react";
import { ErrorMessage } from "../../../design/fieldset";

interface Props {
  onFileSelected: (file: File) => void;
}

interface Errors {
  file?: string;
}

const SelectFileStep: React.FC<Props> = ({ onFileSelected }) => {
  const [errors, setErrors] = useState<Errors>({});
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setErrors({}); // Clear previous errors
    const droppedFile = e.dataTransfer.files?.[0];
    if (!droppedFile) return;
    if (
      !droppedFile.name.endsWith(".pdf") &&
      !droppedFile.name.endsWith(".doc") &&
      !droppedFile.name.endsWith(".docx")
    ) {
      setErrors({
        file: "Invalid file type. Please upload a PDF or Word document.",
      });
      return;
    }
    onFileSelected(droppedFile);
  };

  const handleFileClick = () => {
    fileInputRef.current?.click();
  };

  return (
    <div
      className="flex flex-col items-center justify-center p-6 text-sm text-center border-2 border-dashed rounded-md cursor-pointer text-zinc-500 hover:bg-zinc-50 dark:hover:bg-zinc-800"
      onDrop={handleFileDrop}
      onDragOver={(e) => e.preventDefault()}
      onClick={handleFileClick}
    >
      <p>Drag and drop a file here, or click to browse</p>
      <input
        type="file"
        accept=".pdf,.doc,.docx"
        className="hidden"
        ref={fileInputRef}
        onChange={(e) => onFileSelected(e.target.files![0])}
      />
      {errors.file && <ErrorMessage>{errors.file}</ErrorMessage>}
    </div>
  );
};

export default SelectFileStep;
